import { api } from './auth.service';

const negocioCallService = {

  // Lista calls de um negócio. Aceita filtro opcional `fase` ('C' = Comercial,
  // 'T' = Técnica). Sem fase = todas.
  listar: async (negocioId, fase) => {
    const url = fase
      ? `/calls/negocio/${negocioId}?fase=${encodeURIComponent(fase)}`
      : `/calls/negocio/${negocioId}`;
    const res = await api.get(url);
    return res.data;
  },

  listarParticipantes: async (callId) => {
    const res = await api.get(`/calls/${callId}/participantes`);
    return res.data;
  },

  // Cria call. Pra criar call técnica, inclua `fase: 'T'` em `dados`.
  criar: async (negocioId, dados) => {
    const res = await api.post(`/calls/negocio/${negocioId}`, dados);
    return res.data;
  },

  alterar: async (negocioId, callId, dados) => {
    const res = await api.put(`/calls/negocio/${negocioId}/${callId}`, dados);
    return res.data;
  },

  cancelar: async (negocioId, callId) => {
    const res = await api.patch(`/calls/negocio/${negocioId}/${callId}/cancelar`);
    return res.data;
  },
};

export default negocioCallService;
